import React from 'react';
import { IconProps } from './types';

const EbookIcon: React.FC<IconProps> = ({ className, fill }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill={fill}>
    <path d="M0 26.6667V24H4L2.66667 22.6667V4H29.3333V22.6667L28 24H32V26.6667H0ZM16 25.3333C16.3778 25.3333 16.6944 25.2056 16.95 24.95C17.2056 24.6944 17.3333 24.3778 17.3333 24C17.3333 23.6222 17.2056 23.3056 16.95 23.05C16.6944 22.7944 16.3778 22.6667 16 22.6667C15.6222 22.6667 15.3056 22.7944 15.05 23.05C14.7944 23.3056 14.6667 23.6222 14.6667 24C14.6667 24.3778 14.7944 24.6944 15.05 24.95C15.3056 25.2056 15.6222 25.3333 16 25.3333Z" />
  </svg>
);

export default EbookIcon;
